import { FormGroup, ValidationErrors } from '@angular/forms';

export class ConfirmEmailValidator {
  static validate( form: FormGroup ): ValidationErrors {
    const email = form.get( 'email' );
    const confirmEmail = form.get( 'confirmEmail' );

    if ( email.value !== confirmEmail.value ) {
      confirmEmail.setErrors( { confirmEmail: true } );
    } else {
      confirmEmail.setErrors( null );
    }

    return null;
  }

  static validateEmail(email: string, confirmEmail: string) {
    return (formGroup: FormGroup) => {
      const emailControl = formGroup.controls[email];
      const confirmEmailControl = formGroup.controls[confirmEmail];

        if ( emailControl.value !== confirmEmailControl.value ) {
          confirmEmailControl.setErrors( { confirmEmail: true } );
        } else {
          confirmEmailControl.setErrors( null );
        }

        return null;
    }
  }
}
